import Header from './components/FrontHeader';
import { Outlet } from 'react-router-dom';
import style from './style/FrontLayout.module.less';
import Footer from '@/common/footer/Footer';
import Breadcrumb from '../front/components/Breadcrumb';

const Content = () => {
  return (
    <div className={style.frontContainer}>
      <Breadcrumb></Breadcrumb>
      <Outlet></Outlet>
    </div>
  );
};

const FrontLayout = () => {
  return (
    <>
      <Header bottom />
      <div className={style.frontContent}>
        <Content />
      </div>
      <Footer className={style.footer}></Footer>
    </>
  );
};

export default FrontLayout;